export default __webpack_public_path__ + "static/media/member.647c5672.svg";